<template>
  <div class="sidepanel">
    <div class="header px-4 py-3 d-flex align-items-center justify-content-between">
      <span class="ap-title ap-title__main">{{ $tc('global.file', 2) }}</span>
      <div>
        <slot />
      </div>
    </div>
    <div class="content">
      <div class="element">
        <div
          v-for="(attachment, index) in attachments"
          :key="attachment.attachmentId"
          class="file d-flex align-items-center justify-content-between px-3"
        >
          <span>
            <b-button
              class="btn secondary-button btn-main"
              @click="downloadAttachment(attachment.attachmentId, index)"
            >{{ attachment.filename }}</b-button>
          </span>
        </div>
        <div
          v-if="!attachments || !attachments.length"
          class="d-flex justify-content-center flex-column align-items-center mt-3"
        >
          <div>
            <i
              class="fal fa-unlink"
              aria-hidden="true"
            />
          </div>
          <span>{{ $t('incidents.grid.noAttach') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import incidentAttachmentService from '@/api/resources/attachment/incidentAttachmentService'
import { saveAs } from 'file-saver'

export default {
    name: 'AttachmentSidepanel',
    props: {
        incidentId: { type: Number, required: true }
    },
    data() {
        return {
            attachments: []
        }
    },
    computed: {
        labId() {
            return this.$store.getters.labId
        }
    },
    watch: {
        incidentId(newIncidentId) {
            this.loadAttachments(newIncidentId)
        }
    },
    created() {
        this.loadAttachments(this.incidentId)
    },
    methods: {
        async downloadAttachment(attachmentId, index) {
            const [err, blob] = await this.toCall(incidentAttachmentService.getFile(this.labId, this.incidentId, attachmentId))
            if (err) {
                this.showErrorModalGlobal()
            }
            saveAs(blob, this.attachments[index].filename)
        },
        async loadAttachments(incidentId) {
            if (!incidentId) {
                this.attachments = []
                return
            }
            const [err, result] = await this.toCall(incidentAttachmentService.getIncidentAttachments(this.labId, incidentId))
            if (err) {
                this.showErrorModalGlobal()
            }
            this.attachments = result
        }
    }
}

</script>
